import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { KnowledgeBaseArticleLinkModule } from '@app/pipes/knowledge-base-article-link.module';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@sb/ui/button';
import { SbDialogModule } from '@sb/ui/dialog';
import { RadioCardComponent } from '@sb/ui/radio-card';
import { RadioCardGroupComponent } from '@sb/ui/radio-card-group';

import { TemplateCategory } from '../../models/contract-template.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-template-type-selection-modal',
  standalone: true,
  imports: [
    SbDialogModule,
    TranslatePipe,
    ButtonComponent,
    RadioCardGroupComponent,
    RadioCardComponent,
    ReactiveFormsModule,
    KnowledgeBaseArticleLinkModule,
  ],
  templateUrl: './template-type-selection-modal.component.html',
  styleUrls: ['./template-type-selection-modal.component.scss'],
})
export class TemplateTypeSelectionModalComponent {
  private dialogRef = inject(DialogRef<TemplateCategory>);
  TemplateCategory = TemplateCategory;

  templateTypeControl = new FormControl<TemplateCategory>(TemplateCategory.HIRE, {
    validators: [Validators.required],
  });

  close(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (this.templateTypeControl.valid) {
      this.dialogRef.close(this.templateTypeControl.value);
    }
  }
}
